module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/VGROULETTE-487477101710c76357f03a0b9f136dfc.png";